import { qs, qsAll } from "scripts/data_utils/domHelpers";
import doFetch from "scripts/data_utils/doFetch";

function delayedAction(func) {
  setTimeout(() => func(), 200);
}

function closeNotification(notification) {
  notification.classList.remove("open");
  delayedAction(() => notification.parentNode && notification.parentNode.removeChild(notification));
} // status = error или success


function notificationTemplate(text, status) {
  const notification = document.createElement("div");
  notification.classList.add("notification");
  notification.innerHTML = `<button class="js-close dialog-close"></button>
                            <i class="icon icon--small icon--${status} notification__icon"></i>
                            <div class="notification__text">${text}</div>`;
  qs(".js-close", notification).addEventListener("click", () => closeNotification(notification));
  setTimeout(() => closeNotification(notification), 10000);
  return notification;
}

function showNotification(params) {
  const {
    text,
    status
  } = params;
  const container = qs(".js-notification-container");
  const notification = notificationTemplate(text, status);
  delayedAction(() => notification.classList.add("open"));
  const allNotification = qsAll(".notification", container);

  if (allNotification.length > 5) {
    closeNotification(container.firstChild);
  }

  allNotification.map(el => el.innerHTML === notification.innerHTML && closeNotification(el));
  container.appendChild(notification);
}

export function getNotificationsCounter() {
  doFetch('/api/notifications/count').then(response => {
    if (response.result && response.result.total > 0) {
      const counterElement = qs('.js-notifications-bell_counter');
      const counterText = response.result.total > 99 ? '99+' : String(response.result.total);
      counterElement.innerText = counterText;
      counterElement.classList += ' notifications-bell_counter__visible';
    }
  });
}
export default showNotification;